import {Deserializable} from '../deserializable';
import {Staffs} from '../staff/staffs';
import {NhomVanBanDi} from './nhomvanbandi';
import {VanBanDiFile} from './vanbandifile';
export  class VanBanDi implements Deserializable
{
  public  id: number;
  public  maNhomVBdi: number;
  public  soVaoSo: string;
  public  trichYeu: string;
  public  ngayKy: string;
  public  maNguoiKy: number;
  public  ngayVaoSo: string;
  public  maLoaiVB: number;
  public  maLinhVuc: number;
  public  maDoMat: number;
  public  maDoKhan: number;
  public  noiNhan: string;
  public  maNguoiSoanThao: number;
  public  thoiHan: string;
  public  maNguoiChuTri: number;
  public  noiDungXL: string;
  public  maTrangThaiXL: number;
  public  ghiChu: string;
  public  phoCap: number;
  public  usersRead: string;
  public  soLuotDoc: number;
  public  maVBGoc: number;
  public  loiNhanVT: string;
  public  kieuDuThao: number;
  public  maNguoiDG: number;
  public  xepLoaiDG: number;
  public  sudung: number;
  public  choXem: number;
  public  nguoiNhapID: number;
  public  soVanThuID: number;
  public  nguoiKy: Staffs;
  public nhomVanBanDi: NhomVanBanDi;
  public  vanBanDiFiles: VanBanDiFile[];
  public nguoiChuTri: Staffs;
  public stt: number;
  deserialize(input: any): this {
    Object.assign(this, input);
    this.nguoiKy = input.nguoiKy!= null ? new Staffs().deserialize(input.nguoiKy): null;
    this.nguoiChuTri = input.nguoiChuTri!= null ? new Staffs().deserialize(input.nguoiChuTri): null;
    this.nhomVanBanDi = input.nhomVanBanDi!= null ? new NhomVanBanDi().deserialize(input.nhomVanBanDi): null;
    this.vanBanDiFiles = input.vanBanDiFiles != null ? input.vanBanDiFiles.map(vanBanDiFiles => new VanBanDiFile().deserialize(vanBanDiFiles)):[];
    return this;
  }
}
